import React from 'react';
import {highlightInMap, clearMapHighlight, clearCarouselFocus} from '../../../actions/greatPlaces';
import {goToPinnedSerp, showDatesPopup} from '../../../actions/search';
import {pushEdapEvent} from '../../../utils/edap';
import {ACTION_LOCATION} from './config';

export function sendToEdap(tripleId, eventrefinements, position) {
    const eventRefinements = eventrefinements && parseInt(eventrefinements, 10) ? `filter:${eventrefinements},position:${position}` : `${eventrefinements},position:${position}`;
    const eventPosition = `position:${position}`;

    const mainData = {
        actionlocation: ACTION_LOCATION,
        listingid: tripleId,
        eventrefinements: eventrefinements ? eventRefinements : eventPosition
    };

    pushEdapEvent('property.tile.click', mainData);
}


export function onCardClick({dispatch, listing, segmentKey, types, position}) {
    return (evt) => {
        // `evt.defaultPrevented ||`
        // Make sure the trip board button wasn't clicked; or
        // `evt.target.className.includes...`
        // Make sure the event is received by the intended element.
        // prevents a bug in SimpleImageCarousel where fast button clicking causes the event to be handled by the wrong element.
        if (evt.defaultPrevented || evt.target.className.includes('GreatPlaceRatioCard__img-container')) {
            return;
        }

        sendToEdap(listing.tripleId, types, position);

        evt.preventDefault();

        const {propertyName, tripleId, listingUri, currentIndex} = listing;
        const thumbnailUrlName = currentIndex === 0 ? 'thumbnailUrl' : `thumbnailUrl${currentIndex + 1}`;

        dispatch(showDatesPopup({
            actionLocation: ACTION_LOCATION,
            eventrefinements: types,
            goToSerpAction: goToPinnedSerp,
            propertyName,
            tripleId,
            listingUri,
            thumbnailUrl: listing[thumbnailUrlName],
            refinementKey: segmentKey
        }));
    };
}

export function onMouseOverCard(dispatch, id) {
    return () => {
        dispatch(highlightInMap(id));
        dispatch(clearCarouselFocus());
    };
}

export function onMouseOutCard(dispatch) {
    return () => {
        dispatch(clearMapHighlight());
    };
}

export function listingAsPropertyRatioCard({
    actionLocation = ACTION_LOCATION,
    dispatch,
    types,
    highlightedId,
    isMobile,
    isTablet,
    simpleName,
    tripboardComponent: TripboardComponent,
    segmentKey,
    Card
}) {
    return (listing, index) => (
        <Card
            actionLocation={actionLocation}
            highlighted={listing.id === highlightedId}
            images={[listing.thumbnailUrl, listing.thumbnailUrl2, listing.thumbnailUrl3]}
            currentIndex={listing.currentIndex}
            instantBookable={listing.tooltip}
            isMobile={isMobile}
            isTablet={isTablet}
            key={listing.id}
            link={`//${listing.listingUri}`}
            onClick={onCardClick({dispatch, listing, types, segmentKey, position: index + 1})}
            onMouseOut={onMouseOutCard(dispatch)}
            onMouseOver={onMouseOverCard(dispatch, listing.id)}
            position={index}
            price={listing.price}
            propertyName={listing.propertyName}
            review={listing.review}
            toplineDescription={listing.toplineDescription}
            tripleId={listing.tripleId}
            tripboardComponent={TripboardComponent}
            simpleName={simpleName}
            breadcrumbs={listing.breadcrumbs}
            distanceFrom={listing.distanceFrom}
            badges={listing.badges}
        />
    );
}
